
import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class LoginForm {
	constructor(parent) {
		[this.el, this.$] = DojoTemplates('LoginForm');
		this.$.callout.style.display = 'none';
		this.$.actionButton.addEventListener('click', (evt)=>{
			this.action(evt);
		});
		let altClick = (evt)=>{
			evt.stopPropagation();
			evt.preventDefault();			
			this.setState(evt.target.getAttribute('data-state'));
		}
		for (let a of [this.$.altAction1, this.$.altAction2]) {
			a.addEventListener('click',altClick);
		} 
		this.setState('login');
		parent.appendChild(this.el);
	}
	displayMessage(txt) {
		this.$.callout.textContent = txt;
		this.$.callout.className = "callout success";
		this.$.callout.style.display = 'block';
	}
	displayError(txt) {
		this.$.callout.textContent = txt;
		this.$.callout.className = "callout alert";
		this.$.callout.style.display = 'block';
	}
	hideCallout() {
		this.$.callout.style.display = 'none';
	}
	action(evt) {
		evt.stopPropagation();
		evt.preventDefault();
		switch (this.state) {
			case 'login':
				DojoDeshi.instance().RPCHttp()
				.LoginUser(this.$.identity.value,this.$.password.value)
				.then(
					(res)=>{
						let [success, cookieval] = res;
						if (success) {
							document.cookie = `dojo-deshi-id=${cookieval};path=/`
							document.location = "/classrecord/summary";
						}
						// console.log(`received result: `, res);
					}, (err)=>{
						this.displayError('Login failed. Please try again.');
					});			
				break;
			case 'register':
				DojoDeshi.instance().RPCHttp()
				.StudentRegisterByEmailOrMobile(this.$.identity.value)
				.then(
					(res)=>{
						stype = res[0];
						this.displayMessage(`Your password has been sent to ${this.$.identity.value}. Please login.`);
						this.setState('login');
					}, (err)=>{
						if ("ErrStudentExists"==err.message) {
							this.displayError(`That user already exists. Perhaps try Forgotten to reset your password.`);
							return
						}
						this.displayError(`An error: ${err.message}`);
						console.error(err);
					})
				break;
			case 'forgot':
				DojoDeshi.instance().RPCHttp()
				.StudentResetPasswordByEmailOrMobile(this.$.identity.value)
				.then(
					(res)=>{
						stype = res[0];
						if ("NoSuchStudent"==stype) {
							this.displayError(`Sorry, we don't have a record for ${this.$.identity.value}. Perhaps you can register?`);
						} else {
							this.displayMessage(`A new password has been sent to ${this.$.identity.value}. Please login.`);
							this.setState('login');							
						}
					}, (err)=>{
						this.displayError(`Oops- an error occurred: ${err.message}`);
						console.error(err);
					});
				break;
		}
	}
	setAlt(alt, state, text) {
		alt.textContent = text;
		alt.setAttribute('data-state', state);
	}
	setActions(actText, alt1, alt1Text, alt2, alt2Text) {
		this.$.actionButton.textContent = actText;
		this.setAlt(this.$.altAction1, alt1, alt1Text);
		this.setAlt(this.$.altAction2, alt2, alt2Text);
	}
	setState(state) {
		this.state = state;
		// this.$.callout.style.display = 'none';
		switch (state) {
			case 'login':
				this.setActions('Login','register','Register','forgot','Forgotten');
				this.$.passwordContainer.style.visibility = 'visible';
				return;
			case 'register':
				this.setActions('Register','login','Login','forgot','Forgotten');
				this.$.passwordContainer.style.visibility = 'hidden';
				return;
			case 'forgot':
				this.setActions('Forgotten','login','Login','register','Register');
				this.$.passwordContainer.style.visibility = 'hidden';
				return;
		}
	}
}

window.LoginForm = LoginForm;